export const currency = '$';
export const currentYear = new Date().getFullYear();
export const developedByLink = 'https://techzaa.getappui.com/';
export const developedBy = 'Techzaa';
export const contactUs = 'techzaastudio@gmail.com';
export const buyLink = '';
export const basePath = '';
export const DEFAULT_PAGE_TITLE = 'Reback React | Responsive Admin Dashboard Template';
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'purple', 'pink', 'orange', 'light', 'link'];